import { type SVGProps } from "react";

export function FireIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.941C14.333 7.633 12.167 3.118 11 2C11 5.395 8.765 7.299 7.333 8.706C5.903 10.114 5 12.327 5 14.294C5 17.998 8.134 21 12 21C15.866 21 19 17.998 19 14.294C19 12.582 17.768 9.891 16.667 8.706C14.583 12.059 13.41 12.059 12 10.941Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FireFilledIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.15055 0.904666C7.32236 0.831437 7.52149 0.867335 7.65641 0.996463C8.12676 1.44706 8.71759 2.47563 8.99626 3.65987C9.24819 4.7308 9.26049 6.00696 8.63102 7.15857C8.87101 7.28889 9.04552 7.29825 9.22021 7.23149C9.54825 7.10592 10.0215 6.67411 10.715 5.55831L10.7463 5.51404C10.8245 5.41561 10.9399 5.35181 11.0666 5.33956C11.2113 5.32559 11.3543 5.38026 11.4533 5.4867C11.8692 5.93433 12.2839 6.63233 12.5933 7.35063C12.9012 8.06569 13.1336 8.86742 13.1336 9.52967C13.1336 12.2754 10.8161 14.4672 8.00016 14.4672C5.18419 14.4672 2.8667 12.2754 2.8667 9.52967C2.86676 8.09564 3.51738 6.49964 4.56136 5.47172C5.54788 4.50243 6.8667 3.36851 6.8667 1.3337C6.86677 1.14684 6.97868 0.978026 7.15055 0.904666Z"
        fill="currentColor"
      />
    </svg>
  );
}
